import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ResponsiveRadar } from '@nivo/radar'
import { CompetenciesProfileRootPageAssessmentFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { normalizeData } from './normalizeData'

interface Props {
  assessments: CompetenciesProfileRootPageAssessmentFragment[]
}

const SpiderWeb: React.FC<Props> = ({ assessments }) => {
  const assessmentData = assessments.map((assessment) => ({
    competencyName: assessment.competency?.name ?? '',
    competencyRange: [assessment.scaleMin, assessment.scaleMax],
    optionValue: assessment.score,
  }))

  const { max, data } = normalizeData(assessmentData)

  return (
    <Box padding="s12" style={{ height: '600px' }}>
      <ResponsiveRadar
        data={data}
        colors={['#FFFFFF00', '#68CC45']}
        margin={{ top: 40, right: 100, bottom: 40, left: 100 }}
        indexBy="name"
        keys={['max', 'rating']}
        maxValue={max}
        gridLevels={5}
        dotBorderWidth={2}
        gridLabelOffset={34}
        borderColor={{ from: 'color' }}
        isInteractive={false}
      />
    </Box>
  )
}

export default observer(SpiderWeb)
